import { ContactPolicy } from 'common/dist/types/module.optimization';

export const SPEAKING_CONTACT_POLICY_TYPE: {
  [x in ContactPolicy['contactPolicyType']]: string;
} = {
  count: 'Count',
};
